import {type SimpleProductType} from 'constants/flow/flowTypesProduct';
import {type QuoteItemType} from 'constants/flow/flowTypesCart';

/**
 * Find total price with discount
 * @param {SimpleProductType | QuoteItemType} product - product info
 * @returns {string | number} Total price with discount
 */
export const findTotalPriceWithDiscount = (product: SimpleProductType | QuoteItemType): number =>
    Number(product.row_total_discounted_price) || Number(product.total) || 0;

/**
 * Find price with discount
 * @param {SimpleProductType | QuoteItemType} product - product info
 * @returns {string | number} Price with discount
 */
export const findPriceWithDiscount = (
    product: SimpleProductType | QuoteItemType,
): string | number =>
    product.product_final_price ||
    product.finalPrice ||
    product.final_price ||
    product.final_price_with_tax ||
    product.specialPrice ||
    product.price ||
    findTotalPriceWithDiscount(product);
